export default "__VITE_ASSET__78771b6a__"